define(function () {
        const deviceInfo = {
            isTouching: false,
            pointerDown: false
        };

        window.addEventListener('touchstart', function onFirstTouch() {
            deviceInfo.isTouching = true;
            window.removeEventListener('touchstart', onFirstTouch, false);
        }, false);

        return deviceInfo;
    }
);



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/deviceinfo/deviceInfo.js